// src/components/modalForm/ModalFooter.js
import React from 'react';
import './ModalFooter.css';
import { useModalForm } from './ModalFormContext';
import { orderModalActions } from './ModalActions';

const ModalFooter = ({ children, className = '', style }) => {
  const { variant } = useModalForm();
  return (
    <div className={`modal-footer d-flex justify-content-end ${className}`.trim()} style={style}>
      {variant === 'cadastro' ? orderModalActions(children) : children}
    </div>
  );
};

export default ModalFooter;
